import React, { Component } from "react"
import { Link } from "gatsby"
import { ShipXLogo } from "../components/svg"
import { Grid, Col } from "../components"

class Header extends Component {
  state = {
    showMenu: false,
  }

  toggleMenu = () => {
    this.setState({ showMenu: !this.state.showMenu })
  }

  render() {
    const menuState = this.state.showMenu

    const menu = [
      {
        anchorText: "Home",
        link: "/",
        button: false,
        buttonType: "",
      },
      {
        anchorText: "Services",
        link: "/services/",
        button: false,
        buttonType: "",
      },
      {
        anchorText: "About Us",
        link: "/about/",
        button: false,
        buttonType: "",
      },
      {
        anchorText: "Blog",
        link: "/blog/",
        button: false,
        buttonType: "",
      },
      {
        anchorText: "Track a Package",
        link: "/shipment-tracker/",
        button: true,
        buttonType: "secondary",
      },
      {
        anchorText: "Contact Us",
        link: "/contact/",
        button: true,
        buttonType: "primary",
      },
    ]

    return (
      <header className="w-full z-50 top-0 sm:justify-between py-2 fixed ">
        <nav className="flex items-center justify-between flex-wrap z-10 top-0 lg:mt-8 global-container-x">
          <Link to="/">
            <ShipXLogo className="w-48" />
          </Link>
          <div
            className="flex-grow lg:flex lg:items-center lg:w-auto"
            id="nav-content"
          >
            <div className="list-reset lg:flex justify-end flex-1 items-center hidden">
              {menu.map((item, index) => (
                <div key={index} className="mr-3 last:mr-0">
                  <Link
                    to={item.link}
                    className={
                      item.button && item.buttonType === "primary"
                        ? `ml-2 px-4 py-2 text-white text-sm font-semibold rounded-3xl bg-accent-light hover:bg-accent transition duration-150 ease-in-out`
                        : item.button && item.buttonType === "secondary"
                        ? `ml-2 px-4 py-2 text-white text-sm font-semibold rounded-3xl bg-transparent border border-gray-50 hover:bg-accent transition duration-150 ease-in-out`
                        : `inline-block font-semibold text-sm text-gray-300 no-underline hover:text-accent py-2 px-4 transition duration-150 ease-in-out`
                    }
                    activeClassName={
                      item.button
                        ? `text-white font-semibold`
                        : `text-accent-light hover:text-accent-light font-semibold`
                    }
                  >
                    {item.anchorText}
                  </Link>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:hidden">
            <button
              onClick={this.toggleMenu}
              className="text-white focus:outline-none"
            >
              <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24 ">
                {!menuState ? (
                  <path d="M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z" />
                ) : (
                  <path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z" />
                )}
              </svg>
            </button>
          </div>
        </nav>
        <Grid
          classes={`${
            menuState
              ? `absolute lg:hidden bg-gray-800 w-full block px-2 py-6 z-10`
              : `hidden px-2 py-0`
          } items-center`}
        >
          {menu.map((item, index) => (
            <Col key={index} classes={item.button ? "py-4" : "py-0"}>
              <Link
                to={item.link}
                className={
                  item.button && item.buttonType === "primary"
                    ? `ml-2 px-4 py-2 text-white text-sm font-semibold rounded-3xl bg-accent-light hover:bg-accent transition duration-150 ease-in-out`
                    : item.button && item.buttonType === "secondary"
                    ? `ml-2 px-4 py-2 text-white text-sm font-semibold rounded-3xl bg-transparent border border-gray-50 hover:bg-accent transition duration-150 ease-in-out`
                    : `inline-block font-semibold text-sm text-gray-300 no-underline hover:text-accent py-2 px-4 transition duration-150 ease-in-out`
                }
              >
                {item.anchorText}
              </Link>
            </Col>
          ))}
        </Grid>
      </header>
    )
  }
}

export default Header
